import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-8 bg-blue-50/50 shadow-xl shadow-indigo-400/10 border border-indigo-200 rounded-3xl" }
const _hoisted_2 = { class: "text-lg font-semibold" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = {
  key: 2,
  class: "italic"
}
const _hoisted_6 = ["textContent"]
const _hoisted_7 = {
  key: 1,
  class: "mt-1.5"
}
const _hoisted_8 = { class: "-m-1 flex flex-wrap" }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_11 = { class: "-m-1.5 flex flex-wrap" }
const _hoisted_12 = ["href", "title", "aria-label"]

import { computed, toRefs } from 'vue';
import { TokenExtensions } from '@/utils/tokenRegistry';
import { TokenMintAccount } from '@/models';
import { getAccountRoute, shortenPublicKey } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  props: {
    mint: null
  },
  setup(__props: any) {

const props = __props as {
  mint: TokenMintAccount,
}



const { mint } = toRefs(props);

const linksMap = [
  {
    key: 'website',
    icon: 'icon-globe',
    url: (value: string) => value,
  },
  {
    key: 'twitter',
    icon: 'icon-twitter',
    url: (value: string) => value,
  },
  {
    key: 'discord',
    icon: 'icon-discord',
    url: (value: string) => value,
  },
  {
    key: 'coingeckoId',
    icon: 'icon-coins',
    url: (value: string) => `https://www.coingecko.com/en/coins/${value}`,
  },
];

const links = computed(() => {
  if (!mint.value.tokenInfo) return [];
  return linksMap.flatMap((link) => {
    const extension = mint.value.tokenInfo?.extensions?.[link.key as keyof TokenExtensions];
    if (!extension) return [];
    return { ...link, value: extension };
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, [
        (_unref(mint).tokenInfo?.symbol)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              textContent: _toDisplayString(`${_unref(mint).tokenInfo.name} (${_unref(mint).tokenInfo.symbol})`)
            }, null, 8, _hoisted_3))
          : (_unref(mint).tokenInfo?.name)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                textContent: _toDisplayString(`${_unref(mint).tokenInfo.name}`)
              }, null, 8, _hoisted_4))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, "Unregistered Token"))
      ]),
      _createVNode(_component_router_link, {
        class: "block text-gray-500 hover:text-gray-900 text-sm",
        to: _unref(getAccountRoute)(_unref(mint).publicKey)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(shortenPublicKey)(_unref(mint).publicKey, 10)), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      (_unref(mint).tokenInfo?.extensions?.description)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "mt-4 text-sm text-gray-500",
            textContent: _toDisplayString(_unref(mint).tokenInfo.extensions.description)
          }, null, 8, _hoisted_6))
        : _createCommentVNode("", true),
      (_unref(mint).tokenInfo?.tags?.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("ul", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mint).tokenInfo.tags, (tag) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: tag,
                  class: "px-2 py-0.5 text-xs font-medium bg-blue-50 border border-indigo-200 text-indigo-400 rounded-md inline-block m-1",
                  textContent: _toDisplayString(tag)
                }, null, 8, _hoisted_9))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(links))
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("ul", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(links), (link) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: link.key,
                  class: "m-1.5"
                }, [
                  _createElementVNode("a", {
                    href: link.url(link.value),
                    target: "_blank",
                    title: link.key,
                    "aria-label": link.key,
                    class: "text-gray-500 hover:text-blue-700"
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(link.icon), { class: "w-6 h-6" }))
                  ], 8, _hoisted_12)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})